module.exports = __webpack_public_path__ + "static/media/ricardo-pimenta.5d44925e.png";